import { readerNotes, tags } from "@/mocks/home";

export default function NotesSection() {
  return (
    <section className="w-full border-b border-background-200 bg-background-50">
      <div className="mx-auto grid w-full max-w-7xl grid-cols-1 gap-10 px-4 py-14 md:px-6 md:py-16 lg:grid-cols-[1.35fr_1fr] lg:gap-14">
        <div>
          <span className="flex items-center gap-2 text-xs font-label tracking-wide text-secondary-600">
            <i className="ri-chat-quote-line" />
            读者短评
          </span>
          <h2 className="mt-2 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
            他们是这样读的
          </h2>

          <div className="mt-7 space-y-4">
            {readerNotes.map((n) => (
              <div
                key={n.name}
                className="rounded-lg border border-background-200 bg-background-100 p-4 md:p-5"
              >
                <div className="flex items-center justify-between gap-4">
                  <div className="flex items-center gap-3">
                    <span className="flex h-9 w-9 items-center justify-center rounded-full bg-primary-100 font-heading text-sm font-bold text-primary-700">
                      {n.name.slice(0, 1)}
                    </span>
                    <span className="font-heading text-sm font-bold text-foreground-950">
                      {n.name}
                    </span>
                  </div>
                  <span className="shrink-0 text-xs font-label text-foreground-400">{n.time}</span>
                </div>
                <p className="mt-3 text-sm leading-6 text-foreground-600">{n.text}</p>
              </div>
            ))}
          </div>
        </div>

        <div>
          <span className="flex items-center gap-2 text-xs font-label tracking-wide text-accent-700">
            <i className="ri-price-tag-3-line" />
            热门标签
          </span>
          <h2 className="mt-2 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
            按兴趣挑选
          </h2>

          <div className="mt-7 flex flex-wrap gap-2">
            {tags.map((t) => (
              <button
                key={t}
                type="button"
                className="whitespace-nowrap rounded-full border border-background-300 bg-background-100 px-3.5 py-1.5 text-sm font-label text-foreground-700 transition-colors hover:border-secondary-400 hover:bg-secondary-50 hover:text-secondary-800"
              >
                {t}
              </button>
            ))}
          </div>

          <div className="mt-8 rounded-lg border border-accent-200 bg-accent-50 p-5">
            <h3 className="font-heading text-sm font-bold text-foreground-950">开始你的阅读</h3>
            <p className="mt-2 text-sm leading-6 text-foreground-600">
              建议从第 1 章读起，先认识这位善良的女秘书，再慢慢走进后续的每一段故事。
            </p>
            <button
              type="button"
              onClick={() => {
                const el = document.getElementById("chapters");
                if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
              }}
              className="mt-4 inline-flex items-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-5 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
            >
              <i className="ri-book-open-line" />
              打开章节列表
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}